import React from 'react'

import { PersonAvatar } from '@sketch/components'
import { AddShareMemberNotificationFragment } from '@sketch/gql-types'

import { AvatarWrapper } from './AddShareMemberPreview.styles'
import { DocumentTileMedia } from './DocumentTileMedia'
import { AcceptAction } from './InboxPreviewActions'
import {
  Card,
  Separator,
  Tile,
  TileTitle,
  TileWrapper,
  RoleBadge,
  TileMeta,
} from './TileCard.styles'

interface AddShareMemberPreviewProps {
  notification: AddShareMemberNotificationFragment
}

export const AddShareMemberPreview = ({
  notification,
}: AddShareMemberPreviewProps) => {
  const { share, user, workspace } = notification

  if (!share || !user) return null

  const name = user.name ?? 'Someone'
  const avatarSrc = user.avatar?.small
  const hasPendingInvite = share.userHasUnacceptedInvitationToView === true

  // Temporary disable the thumbnail fetching because of a production issue
  // https://sketch.slack.com/archives/C04851ZU8FM/p1783086250683029?thread_ts=1783006390.487219&cid=C04851ZU8FM
  //
  // const thumbnail = thumbnailForPreviewFile(
  //   share.version?.document?.previewFile
  // )

  const thumbnail = null

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <AvatarWrapper>
            {avatarSrc ? (
              <PersonAvatar
                flavour="image"
                size="96px"
                name={name}
                src={avatarSrc}
              />
            ) : (
              <PersonAvatar flavour="color" size="96px" name={name} />
            )}
          </AvatarWrapper>
          <TileTitle>{name}</TileTitle>
          <RoleBadge variant="secondary">Inviter</RoleBadge>
        </Tile>

        <Separator />

        <Tile>
          <DocumentTileMedia src={thumbnail} alt={`Preview of ${share.name}`} />
          <TileTitle>{share.name}</TileTitle>
          {share.project?.name && <TileMeta>{share.project.name}</TileMeta>}
          {workspace?.name && <TileMeta>{workspace.name}</TileMeta>}
        </Tile>
      </TileWrapper>

      {hasPendingInvite && <AcceptAction shareIdentifier={share.identifier} />}
    </Card>
  )
}
